export default defineNuxtRouteMiddleware(async (to, from) => {
  const headerlessRoutes: string[] = ['/hc'];
  if (headerlessRoutes.includes(to.path)) {
    return;
  }

  // クエリ／ハッシュだけの変更で取り直すと API 3本の直列待ちでルート解決が止まる。
  // Nuxt は初回描画も同一パスの遷移として流すので、SSR とハイドレーション中は除外する。
  if (import.meta.client && !useNuxtApp().isHydrating && to.path === from.path) {
    return;
  }

  const { fetchCurrentUser } = useAuth();
  const { fetchCartInfo } = useCart();

  // **直列にしない。** ここはパスが変わるたびに走り、**解決するまでルートが進まない**。
  // `useCart` は `useAuth` を参照しておらず（カートはセッションcookieでサーバが解決する）、
  // 2本のあいだにデータ依存が無いので並列でよい。
  // 直列だと往復ぶんの待ちがそのまま「押しても何も起きない時間」になる（#1386）。
  //
  // 例外の出方は変わらない — 投げうるのは `fetchCurrentUser`（401以外）だけで、
  // `fetchCartInfo` は内部で握って既定値を返す。
  await Promise.all([fetchCurrentUser(), fetchCartInfo()]);
});
